var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment')
var heading = require('../components/heading');
var key = require('../libs/keybindings');
var session = require('../auth/models/session');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var loaders = require('../layout/components/loaders');
var buttonElement = require('../components/button');
var alerts = require('../layout/components/alerts'); 
var Model = require('../libs/Model');
var choices = require('../libs/choices');
var certifiedInstrumentGroups = require('./certifiedInstrumentGroups');
var instrumentCertificateDates = require('./instrumentCertificateDates');
var certifiedInstrumentDateSummary = require('./certifiedInstrumentDateSummary');
var certifiedInstrument = modalForm(Object.assign(require('../../../../models/assets/certifiedInstrument'), Model));
var instrumentCertificate = modalForm(Object.assign(require('../../../../models/assets/instrumentCertificate'), Model));
instrumentCertificateDates.configureInstrumentCertificateDates(instrumentCertificate);
var dateFormat = 'MM/DD/YYYY HH:mm';

var oninit = function() {
  var ctrl = this;
  alerts.vm.clear();
  certifiedInstrument.errors = [];
  ctrl.init = function() {
    if (m.route.param('key') && (m.route.param('key') !== 'new')) {
      loaders.requestWithLoader({
        method : 'GET',
        url: '/api/v1/certifiedinstrument/' + m.route.param('key'),
        loader: 'main'
      })
      .then(function(res) {
        var reconciled = certifiedInstrumentGroups.reconcileCertifiedInstrumentGroups(res, ctrl.groups);
        certifiedInstrument.initForm.call(certifiedInstrument, reconciled.record);
        ctrl.missingOwnerRids = reconciled.missingOwnerRids;
        ctrl.missingUsedByRids = reconciled.missingUsedByRids;
        ctrl.currentUserIsOwner = certifiedInstrumentGroups.userCanEditCertifiedInstrument(res, session.user(), ctrl.groups);
      });
    } else {
      ctrl.missingOwnerRids = [];
      ctrl.missingUsedByRids = [];
      ctrl.currentUserIsOwner = false;
      certifiedInstrument.initForm.call(certifiedInstrument);
    }
  }

  ctrl.save = function() {
    return certifiedInstrument.save()
    .then(function(pointProfileRecord) {
      if (typeof certifiedInstrument.record['@rid'] === 'undefined') {
       m.route.set('/certifiedinstrument/' + pointProfileRecord['@rid'].slice(1))
      } else {
        ctrl.init();
      }
    })
    .catch((e)=>{
      console.log(e)
      alerts.vm.clear();
      alerts.vm.add({detail: '' + e})
    })
  };

  key('enter', 'certifiedinstrumenteditor', ctrl.save);
  key.setScope('certifiedinstrumenteditor');
  
  modal.on('closed', ctrl.init)

  loaders.requestWithLoader({
    url: '/api/v1/calibration/groups',
    method: 'GET',
  })
  .then(function(groups)  {
    ctrl.groups = groups.map(function(group, idx) {
      return {key: group.name, value: group['@rid']}
    })
  
    ctrl.userGroups = parseInt(session.user().isCalibrationSuperuser) ? 
      ctrl.groups
    :
      session.user().groups.map(function(group, idx) {
        return {key: group.name, value: group['@rid']}
      })
    ctrl.init();
  });
};


var onremove = function() {
  alerts.vm.clear();
  certifiedInstrument.initForm.call(certifiedInstrument);
  modal.off('closed', this.init);
  key.setScope('home');
}

var view = function() {
  var ctrl = this;
  if (!certifiedInstrument.record || !ctrl.groups) {
    return m('div')
  }

  return m('div.container.mb5', [
    m('div.flex.justify-between.mb3.pb1.bb.bw1.b--mid-gray.near-white', [
      m('div.f-subheadline', [
          m('div.mr2.dib-ns', [
            m(m.route.Link, {href:'/certifiedinstruments'}, 'Certified Instruments'),
            ' / '
          ]),
          m('div.mr2.dib-ns', [
            m('span', certifiedInstrument.record['@rid'] ? 'Edit ' + certifiedInstrument.record.name : 'New Certified Instrument')
          ])
      ])
    ]),
    function() {
      if (certifiedInstrument.record['@rid']) {
        certifiedInstrument.record.usedBy = prop(certifiedInstrument.record.usedBy)
        var dateSummary = certifiedInstrumentDateSummary.buildCertifiedInstrumentDateSummary(certifiedInstrument.record);
        return m('div', [
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m('p', 'Calibration Instrument: '),
            m('p', certifiedInstrument.record.name),
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m('p', 'Model: '),
            m('p', certifiedInstrument.record.model),
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m('p', 'Description: '),
            m('p', certifiedInstrument.record.description),
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m('p', 'Serial Number: '),
            m('p', certifiedInstrument.record.serialNumber),
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m('p', 'Owner: '),
            m('div.w-50', [
              m(choices, { 
                data: ctrl.userGroups, 
                value: certifiedInstrument.form.owner,
                disabled: !ctrl.currentUserIsOwner
              })
            ])
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m('p', 'Used by: '),
            m('div.w-50',[
              m(choices, { 
                data: ctrl.groups, 
                value: certifiedInstrument.form.usedBy,
                disabled: !ctrl.currentUserIsOwner
              })
            ])
          ]),
          m('div', [
            m('div.flex.justify-between.items-center.bb.bw1.pr3', [
              m('p', 'Calibrated On: '),
              m('p', dateSummary.calibratedOn),
            ]),
            m('div.flex.justify-between.items-center.bb.bw1.pr3', [
              m('p', 'Calibration Due: '),
              m('p', dateSummary.calibrationDue),
            ])
          ]),
          ctrl.currentUserIsOwner ?
            m(buttonElement, {
              label:'Save', 
              class: 'mv3',
              func: ctrl.save.bind()
            })
          : ''
        ])
      }else{
        return m("form", [
          m(heading, {label: "Certified Instrument Name"}),
          m("div.mb2",[
            m("input", {
              type: 'text',
              value: certifiedInstrument.form.name(), 
              oninput: function(ev) { certifiedInstrument.form.name(ev.target.value) } 
            })
          ]),
          m(heading, {label: "Model"}),
          m("div.mb2",[
            m("input", {
              type: 'text',
              value: certifiedInstrument.form.model(), 
              oninput: function(ev) { certifiedInstrument.form.model(ev.target.value) } 
            })
          ]),
          m(heading, {label: "Description"}),
          m("div.mb2",[
            m("input", {
              type: 'text',
              value: certifiedInstrument.form.description(), 
              oninput: function(ev) { certifiedInstrument.form.description(ev.target.value) }
            })
          ]),
          m(heading, {label: "Serial Number"}),
          m("div.mb2",[
            m("input", {
              type: 'text',
              value: certifiedInstrument.form.serialNumber(), 
              oninput: function(ev) { certifiedInstrument.form.serialNumber(ev.target.value) }
            })
          ]),
          m("div.mb2",[
            m('p', 'Owner: '),
            m(choices, { 
              data: ctrl.userGroups, 
              value: certifiedInstrument.form.owner,
            })
          ]),
          m("div.mb2",[
            m('p', 'Used by: '),
            m(choices, { 
              data: ctrl.groups, 
              value: certifiedInstrument.form.usedBy,
            })
          ]),
          m(buttonElement, {label:'Save', class: 'mv3',func: ctrl.save.bind()})
        ])
      }
    }(),

    // alarmProfileForm.errorView.call(alarmProfileForm),
    m('div', {class:'form-group'}, [
      m('div.flex.justify-center.f2.pb1.pt2.bb.w-100.bw1', 'Certificates'),
      m('table.w-100.f3.pt2.pb3', [
        m('thead', [
          m('tr', [
            m('th.tc.v-btm.bw1.ph2', [
              m('p.ma0.tc', 'Origin Date')
            ]),
            m('th.tc.v-btm.bw1.ph2', [
              m('p.ma0.tc', 'Expiration Date')
            ]),
            m('th.tc.v-btm.bw1.ph2', [
              m('p.ma0.tc', 'Attachment')
            ]),
          ])
        ]),
        m('tbody', [
          (certifiedInstrument.record.certificates || []).slice().sort(function(a,b) {
            return new Date(b.expirationDate) - new Date(a.expirationDate);
          }).map(function(certRecord, idx) {
            return m('tr', [
              m('td.tc.f2.bb-0.bl-0.b--dotted.bw1', moment(new Date (certRecord.originDate)).format(dateFormat)),
              m('td.tc.f2.bb-0.bl-0.b--dotted.bw1', moment(new Date (certRecord.expirationDate)).format(dateFormat)),
              m('td.tc.f2.br-0.bb-0.bl-0.b--dotted.bw1', [
                m('i.ion-ios-cloud-download.blue', {
                  onclick: function() {
                    var param = encodeURIComponent(certRecord.filename);               
                    fetch(`/api/v1/getCertified?file=${param}`)
                    .then(resp => resp.blob())
                    .then(blob => {
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.style.display = 'none';
                      a.href = url;
                      a.download = certRecord.filename//+'.pdf'; // the filename
                      document.body.appendChild(a);
                      a.click();
                      window.URL.revokeObjectURL(url);
                    })
                    .catch((e) => console.log(e));
                  },
                  style:{marginRight:'1em'}, 
                })
              ])
            ])
          })
        ]) 
      ]),
      ctrl.currentUserIsOwner ?
        m(buttonElement, {
          class: 'mt3 w-100 ' + (certifiedInstrument.record['@rid'] == undefined ? 'dn' : ''),
          label: 'Add Certificate', 
          func: instrumentCertificate.editDialogue.bind(instrumentCertificate, {instrument: certifiedInstrument.record['@rid']})
        })
      : ''
    ])
  ])
};

module.exports = {oninit, view, onremove};
